module.exports = __webpack_public_path__ + "img/Picture 4.ac72b22e.png";